'use client';

import { useQuery } from '@tanstack/react-query';
import SafeImage from '@ui/SafeImage';
import { CategoryDocument } from '@models/category';
import { getMasterProductInfo } from '@util/firestore/products';
import { formatCurrency } from '@util/index';
import Link from 'next/link';
import React from 'react';

const ProductInfo = ({
  title,
  value,
  href,
}: {
  title: string;
  value: string;
  href?: string;
}) => {
  return (
    <div className="flex w-full grow flex-col">
      <span className="font-medium uppercase text-brand-dark-gray">
        {title}
      </span>
      {href ? (
        <Link
          href={href}
          className="text-[1.8rem] font-semibold leading-[2.7rem] text-brand-secondary"
        >
          {value}
        </Link>
      ) : (
        <span className="text-[1.8rem] font-semibold leading-[2.7rem] text-brand-secondary">
          {value}
        </span>
      )}
    </div>
  );
};

const MasterProductCategoryHeader = ({
  category,
  itemsAvailable,
  initialMasterProductInfo,
}: {
  category: CategoryDocument;
  itemsAvailable: number;
  initialMasterProductInfo?: {
    min: number;
    max: number;
    cat1_name: string;
    brand_name: string;
    brand_slug: string;
  };
}) => {
  // const { userDoc } = useAuth();
  const [readMore, setReadMore] = React.useState(false);

  const { data: productInfo } = useQuery({
    queryKey: ['master-product', category.id],
    queryFn: () => getMasterProductInfo(category),
    enabled: !!category && initialMasterProductInfo == null,
    initialData: initialMasterProductInfo,
  });

  return (
    <div className="flex w-full flex-col items-center gap-[2.4rem] py-[3rem] sm:py-[6rem]">
      <div className="flex w-full max-w-[120rem] flex-col items-center justify-center gap-[4rem] sm:flex-row">
        {/* <SafeImage
          className="hidden h-[24rem] w-[24rem] rounded-2xl object-contain sm:block"
          width={240}
          height={240}
          alt={'Image for ' + category.name}
          key={category.image}
          src={category.image}
        /> */}
        <div className="flex grow flex-col gap-[2.4rem] p-[0.8rem] lg:p-0">
          <div className="flex w-full flex-col items-center justify-between gap-[0.8rem] sm:flex-row">
            {/* sm:order-0 order-1 */}
            <div className="flex items-center gap-[0.8rem]">
              <SafeImage
                className="h-[12rem] w-[12rem] rounded-2xl object-contain sm:hidden"
                width={120}
                height={120}
                alt={'Image for ' + category.name}
                key={category.image}
                src={category.image}
              />
              <h1 className="text-[1.8rem] font-semibold text-brand-lightest-black sm:text-[3.2rem]">
                {category.name}
              </h1>
            </div>
          </div>

          <div className="flex w-full flex-col gap-[1.6rem] sm:flex-row">
            {/*TODO FIX LINKS */}
            <ProductInfo
              title={'Category'}
              value={category.name}
              href={category.full_slug}
            ></ProductInfo>
            <ProductInfo
              title={'Items Available'}
              value={itemsAvailable.toString()}
            ></ProductInfo>
            {!!productInfo?.max && (
              <ProductInfo
                title={'Price Range'}
                value={`${formatCurrency(productInfo.min)} - ${formatCurrency(
                  productInfo.max
                )}`}
              ></ProductInfo>
            )}
          </div>
        </div>
      </div>
      {/* <FeatureRow /> */}
    </div>
  );
};

export default MasterProductCategoryHeader;
